import { withStyles } from "@material-ui/styles";
import Button from "Components/Button";
import "cropperjs/dist/cropper.css";
import React, { Component } from "react";
import Cropper from "react-cropper";
import { reduxForm } from "redux-form";
import styled from "styled-components";
import styles from "./styles";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2.5%;
`;

class CroppingForm extends Component {
  constructor(props) {
    super(props);
    this.cropFileInput = React.createRef();
  }
  state = {
    img: null
  };

  componentDidMount() {
    this.setState({
      img: this.props.img
    });
  }

  changeImage = () => {
    const img = this.cropFileInput.current.files[0];
    var reader = new FileReader();

    reader.readAsDataURL(img);

    reader.onload = () => {
      this.setState({
        img: reader.result
      });
    };
  };

  handleSubmit = e => {
    e.preventDefault();
    const newImage = this.refs.cropper.getCroppedCanvas().toDataURL();

    // TODO: base64 is 33% larger than binary files - convert
    // var block = newImage.split(";");
    // // Get the content type of the image
    // var contentType = block[0].split(":")[1];// In this case "image/gif"
    // // get the real base64 content of the file
    // var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

    // // Convert it to a blob to upload
    // var blob = b64toBlob(realData, contentType);

    // // Create a FormData and append the file with "image" as parameter name
    // var formDataToUpload = new FormData();
    // formDataToUpload.append("image", blob);

    this.props.handleSubmit(newImage);
  };

  render() {
    const { img } = this.state;
    const { classes } = this.props;
    return (
      <form onSubmit={this.handleSubmit}>
        <div style={{ margin: "auto", width: "50%" }}>
          <Cropper
            ref="cropper"
            src={img}
            style={{
              margin: "auto",
              marginTop: "25px",
              height: 400,
              width: "100%",
              backgroundColor: "rgba(255, 255, 255)"
            }}
            // Cropper.js options
            aspectRatio={9 / 9}
            guides={false}
            background={false}
            viewMode={3}
            dragMode={"move"}
          />
          <ButtonContainer>
            <div className={classes.changeButton}>
              <Button>
                <label htmlFor={"cropupload"} className={classes.newImage}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    id={"cropupload"}
                    onChange={this.changeImage}
                    ref={this.cropFileInput}
                  />
                  Change Image
                </label>
              </Button>
            </div>
            <div className={classes.cropButton}>
              <Button className={"croppingform-button"} type={"submit"}>
                Crop
              </Button>
            </div>
          </ButtonContainer>{" "}
        </div>
      </form>
    );
  }
}

CroppingForm = reduxForm({
  form: "CroppingForm"
})(CroppingForm);

export default withStyles(styles)(CroppingForm);
